export const iconFontAwesomeTransportationWheelchairMove = (
	<i className="fa-solid fa-wheelchair-move"></i>
);
